import { createAsyncThunk } from '@reduxjs/toolkit';

import { IResourceFile } from '.';
import { AdminApiPaths, APIDataProvider, TApiResponse } from '../../api';

export interface IBrowseResources {
  resourceKey: string;
}

const apiDataProvider = new APIDataProvider();

export const adminBrowseResources = createAsyncThunk(
  'resources/browse',
  async (data: IBrowseResources) => {
    const path = `${AdminApiPaths.resources}/browse?resourceKey=${data.resourceKey}`;
    const response = await apiDataProvider.get<
      TApiResponse<{
        offset: number;
        limit: number;
        totalDocs: number;
        docs: Array<IResourceFile>;
      }>
    >(path);

    return response.data;
  }
);
